import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FiDownload } from '@react-icons/all-files/fi/FiDownload';

import { useAlert } from '@mais-retorno-front/hooks/alert';
import { CircularButton } from '@mais-retorno-front/styles';
import { useAuth } from '@core/features-core/auth/client';

interface IHeader {
  displayName: string;
  value: string;
}

export interface AssetHeaders {
  headers: IHeader[];
}

interface IAssetHeadersProps extends AssetHeaders {
  headerStyle?: any;
  downloadButton?: boolean;
}

export const FieldHeader = ({ displayName, value }: IHeader) => {
  return (
    <Grid item xs={12} sm={3} component="li">
      <Typography fontWeight={700} component="h2" variant="body1">
        {displayName}
      </Typography>
      <Typography>{value}</Typography>
    </Grid>
  );
};

export const AssetHeaders = ({
  headers,
  headerStyle,
  downloadButton = true,
}: IAssetHeadersProps) => {
  const { initialized, userIsLogged: authenticated } = useAuth();

  const { dispatchLoginAlert } = useAlert();

  const handlerDownloadPDF = async () => {
    if (!initialized) return;

    if (!authenticated) {
      return dispatchLoginAlert('Para baixar o PDF você precisa estar logado');
    }

    window.print();
  };

  return (
    <Card component="section" id="asset-headers" sx={headerStyle}>
      <CardContent style={{ display: 'flex' }}>
        <Grid container spacing={2} component="ul" style={{ padding: 0 }}>
          {headers?.map(({ displayName, value }) => (
            <FieldHeader
              key={displayName}
              displayName={displayName}
              value={value}
            />
          ))}
        </Grid>
        {downloadButton && (
          <Box display="flex" alignItems="flex-start" justifyContent="center">
            <CircularButton
              style={{
                backgroundColor: '#fff',
                boxShadow: '0px 2px 7px 0px #00000024',
              }}
              onClick={handlerDownloadPDF}
              aria-label="Baixar PDF"
            >
              <FiDownload size={18} />
            </CircularButton>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
